export default __webpack_public_path__ + "7641536aa1d436db9c5111dd094ad069.png";